import * as THREE from 'three'

export const FRAME_CORRECTION_QUATERNION = new THREE.Quaternion().setFromAxisAngle(
  new THREE.Vector3(0, 1, -1).normalize(),
  Math.PI,
)

export const LEFT_FOREARM_SENSOR_WORLD_MATRIX = new THREE.Matrix4().set(
  0,
  -1,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
)

export const RIGHT_FOREARM_SENSOR_WORLD_MATRIX = new THREE.Matrix4().multiply(
  LEFT_FOREARM_SENSOR_WORLD_MATRIX,
)

export const LEFT_FOREARM_SENSOR_WORLD_QUATERNION = new THREE.Quaternion().setFromRotationMatrix(
  LEFT_FOREARM_SENSOR_WORLD_MATRIX,
)

export const RIGHT_FOREARM_SENSOR_WORLD_QUATERNION = new THREE.Quaternion().setFromRotationMatrix(
  RIGHT_FOREARM_SENSOR_WORLD_MATRIX,
)

export const LEFT_FOREARM_SENSOR_WORLD_QUATERNION_INVERSE =
  LEFT_FOREARM_SENSOR_WORLD_QUATERNION.clone().invert()

export const RIGHT_FOREARM_SENSOR_WORLD_QUATERNION_INVERSE =
  RIGHT_FOREARM_SENSOR_WORLD_QUATERNION.clone().invert()

export function getEffectiveSensorQuaternion(
  orientation: { x: number; y: number; z: number; w: number },
  applyFrameCorrection: boolean,
): THREE.Quaternion {
  const quaternion = new THREE.Quaternion(
    orientation.x,
    orientation.y,
    orientation.z,
    orientation.w,
  ).normalize()

  if (applyFrameCorrection) {
    quaternion.premultiply(FRAME_CORRECTION_QUATERNION)
  }

  return quaternion
}
